var _a, _b, _c, _d, _e, _f, _g, _h;
/* eslint-enable no-var */
var isJestRunning;
try {
    isJestRunning =
        process.env.JEST_WORKER_ID !== undefined && process.env.NODE_ENV == "test";
}
catch (e) {
    isJestRunning = false;
}
import applicationConfiguration from "../../config/application";
var origin = ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname) || "default";
var featureFlags = ((_c = (_b = applicationConfiguration === null || applicationConfiguration === void 0 ? void 0 : applicationConfiguration.environments) === null || _b === void 0 ? void 0 : _b[origin]) === null || _c === void 0 ? void 0 : _c.featureFlags) ||
    ((_e = (_d = applicationConfiguration === null || applicationConfiguration === void 0 ? void 0 : applicationConfiguration.environments) === null || _d === void 0 ? void 0 : _d["default"]) === null || _e === void 0 ? void 0 : _e.featureFlags) ||
    {};
var defaultFlags = (_h = (_g = (_f = applicationConfiguration === null || applicationConfiguration === void 0 ? void 0 : applicationConfiguration.environments) === null || _f === void 0 ? void 0 : _f["default"]) === null || _g === void 0 ? void 0 : _g.featureFlags) !== null && _h !== void 0 ? _h : {};
var hasStorybook = global && global.IS_STORYBOOK;
var commandLineFeatureFlags = process.env.REACT_APP_FEATURE_FLAGS;
var parseFeatureFlags = function (value) {
    if (!value) {
        return {};
    }
    try {
        var parsed = JSON.parse(value);
        return parsed && typeof parsed === "object" && !Array.isArray(parsed)
            ? parsed
            : {};
    }
    catch (_a) {
        console.error("REACT_APP_FEATURE_FLAGS must contain a JSON object");
        return {};
    }
};
var environmentFeatureFlags = parseFeatureFlags(commandLineFeatureFlags);
var truthes = ["true", "1", "yes"];
var falses = ["false", "0", "no"];
var isTruthyString = function (value) {
    if (value == null) {
        return null;
    }
    var stored = (localStorage.getItem("have".concat(value.charAt(0).toUpperCase() + value.slice(1))) || "")
        .toLowerCase()
        .trim();
    if (truthes.includes(stored)) {
        return true;
    }
    if (falses.includes(stored)) {
        return false;
    }
    if (stored) {
        console.error("expected localStorage \"".concat(value, "\" to be one of"), truthes.concat(falses).join(", "));
    }
    return null;
};
export var hasFeatureFlag = function (flag) {
    var isTruthy = isTruthyString(flag);
    if (isTruthy != null) {
        return isTruthy;
    }
    if (environmentFeatureFlags[flag] != null) {
        return !!environmentFeatureFlags[flag];
    }
    if (featureFlags[flag] != null) {
        return !!featureFlags[flag];
    }
    return !!defaultFlags[flag];
};
export var haveDiversityPages = function () {
    return (hasStorybook ||
        isJestRunning ||
        process.env.REACT_APP_HAVE_DIVERSITY_PAGES ||
        localStorage.getItem("haveDiversityPages"));
};
export var haveSuccessProfilePages = function () { return true; };
export var haveTalentReviewPages = function () {
    return (hasStorybook ||
        isJestRunning ||
        process.env.REACT_APP_HAVE_TALENT_REVIEW_PAGES ||
        localStorage.getItem("haveTalentReviewPages"));
};
export var haveOwnedFilters = function () {
    return (process.env.REACT_APP_HAVE_OWNED_FILTERS ||
        localStorage.getItem("haveOwnedFilters"));
};
export var haveLegacyTabs = function () {
    return (process.env.REACT_APP_HEADER_ENABLED_FLAG ||
        localStorage.getItem("haveLegacyTabs"));
};
